import React from "react";
import { Box } from "@mui/material";
import { keyframes } from "@mui/system";
import fusionMsiLogo from "assets/images/logos/fusionmsi-logo.svg";

/**
 * The full-page loader (Loading.js `page`): the satin Fusion MSI star turning over
 * like an hourglass. It rests, flips a half turn, rests, and flips again, for as
 * long as the wait lasts.
 *
 * Uses the canonical brand mark (fusionmsi-logo.svg / StarDraft3), not the old
 * flat two-tone paths.
 */

// One loop is two flips: rest 1s, turn 0.6s, rest 1s, turn 0.6s.
const REST_MS = 1000;
const TURN_MS = 600;
const LOOP_MS = 2 * (REST_MS + TURN_MS);
const pct = (ms) => `${((ms / LOOP_MS) * 100).toFixed(2)}%`;

// Two flips per loop to 360° so a half turn does not leave colours swapped permanently.
const flip = keyframes`
  0%, ${pct(REST_MS)} { transform: rotate(0deg); }
  ${pct(REST_MS + TURN_MS)}, ${pct(2 * REST_MS + TURN_MS)} { transform: rotate(180deg); }
  100% { transform: rotate(360deg); }
`;

export default function FusionLoader({ size = 72 }) {
  return (
    <Box
      // An indeterminate progress bar to assistive tech, like the CircularProgress it replaces.
      role="progressbar"
      aria-label="Loading"
      sx={{
        width: size,
        height: size,
        animation: `${flip} ${LOOP_MS}ms cubic-bezier(0.65, 0, 0.35, 1) infinite`,
        "@media (prefers-reduced-motion: reduce)": { animation: "none" },
      }}
    >
      <Box
        component="img"
        src={fusionMsiLogo}
        alt=""
        sx={{
          width: "100%",
          height: "100%",
          display: "block",
          objectFit: "contain",
        }}
      />
    </Box>
  );
}
